import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {
	acceptTicketAiSuggestedActionMutation,
	AcceptTicketAiSuggestedActionInput,
} from './__generated__/acceptTicketAiSuggestedActionMutation.graphql';

const mutation = graphql`
	mutation acceptTicketAiSuggestedActionMutation($input: AcceptTicketAiSuggestedActionInput!) {
		acceptTicketAiSuggestedAction(input: $input) {
			clientMutationId
			ticket {
				id
				...AiSuggestedActionsList_ticket
				...LinkedTasksTab_ticket
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: AcceptTicketAiSuggestedActionInput,
	onCompleted?: (r: acceptTicketAiSuggestedActionMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<acceptTicketAiSuggestedActionMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'acceptTicketAiSuggestedActionMutation'};
